import React from 'react'
import { Icon, IconProps } from '../components/Icon'
const SvgGo: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.5 9l3.5 3.5M16 12.5L12.5 16M16 12.5H7"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
export default SvgGo
